<template>
    <div>
        <div class="p-3" style="overflow: hidden;">
            <div class="position-relative">
                <div
                    :ref="`textareaCover-${mentionableId}`"
                    class="textarea-cover"
                    v-html="mention"
                />
                <Mentionable
                    ref="mentionable"
                    :class="`mentionable-${mentionableId} mentionable-container`"
                    :keys="keys"
                    :items="mentionTags"
                    offset="6"
                    filtering-disabled
                    insert-space
                    placement="top"
                    omit-key
                >
                    <slot />
                </Mentionable>
            </div>
        </div>
    </div>
</template>

<script>
import translations from "@/utils/translations/global";
import { Mentionable } from "vue-mention";

Mentionable.methods.onKeyDown = function(e) {
    if (this.key) {
        if (e.key === "Escape" || e.keyCode === 27) {
            this.closeMenu();
            this.cancelEvent(e);
        }
        if (e.key === "ArrowDown" || e.keyCode === 40) {
            this.selectedIndex++;
            if (this.selectedIndex >= this.displayedItems.length) {
                this.selectedIndex = 0;
            }
            this.cancelEvent(e);
        }
        if (e.key === "ArrowUp" || e.keyCode === 38) {
            this.selectedIndex--;
            if (this.selectedIndex < 0) {
                this.selectedIndex = this.displayedItems.length - 1;
            }
            this.cancelEvent(e);
        }
        if (
            (e.keyCode === 13 || e.keyCode === 9) &&
            this.displayedItems.length > 0
        ) {
            this.applyMention(this.selectedIndex);
            this.cancelEvent(e);
        }
    }
};

export default {
    name: "BTextarea",

    mixins: [translations],
    components: { Mentionable },
    props: {
        mentionableItems: Array
    },

    data: () => ({
        keys: ["$"],
        inputs: [{}],
        value: "",
        mentionableId: "",
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        mentionTags() {
            return this.mentionableItems.map(e => {
                return {
                    value: `{{${e.value}}}`,
                    label: e.label
                };
            });
        },

        inputIds() {
            let ids = []
            this.inputs.forEach( e => {
                console.log(e.id)
                if (e.id) {
                    ids.push(e.id)
                }
            })
            return ids
        },

        mention() {
            if (typeof this.value?.replaceAll !== "function") {
                return this.value;
            }
            const replaced =
                this.value
                    ?.replaceAll("&", "&amp;")
                    ?.replaceAll(">", "&gt;")
                    ?.replaceAll("<", "&lt;")
                    ?.replaceAll('"', "&quot;")
                    ?.replaceAll("'", "&apos;") + "\n\n";
            const search = new RegExp(
                this.mentionTags
                    .slice()
                    .sort((a, b) => b.value?.length - a.value?.length)
                    .map(v => v.value)
                    .join("|"),
                "g"
            );
            return replaced.replace(search, (match, offset) => {
                return `<span class="mention-str">${match}</span>`
                    .replaceAll("{", "")
                    .replaceAll("}", "");
            });
        }
    },

    methods: {
        resize(i) {
            const barWidth =
                this.inputs[i].getBoundingClientRect().width -
                this.inputs[i].clientWidth -
                2;
            this.$refs[
                `textareaCover-${this.mentionableId}`
            ].style.paddingRight = `calc(12px + ${barWidth}px)`;

            this.$refs[
                `textareaCover-${this.mentionableId}`
            ].style.width = `calc(${this.inputs[i].clientWidth}px)`;
            this.$refs[
                `textareaCover-${this.mentionableId}`
            ].style.maxHeight = `calc(${this.inputs[i].clientHeight + 6}px)`;

            if (this.inputs[i].scrollLeft) {
                this.$refs[
                    `textareaCover-${this.mentionableId}`
                ].style.marginLeft = `-${this.inputs[i].scrollLeft}px`;
                this.$refs[
                    `textareaCover-${this.mentionableId}`
                ].style.width = `calc(${this.inputs[i].clientWidth}px + ${this.inputs[i].scrollLeft}px + 13px)`;
                this.$refs[
                    `textareaCover-${this.mentionableId}`
                ].style.whiteSpace = `nowrap`;
            } else {
                this.$refs[
                    `textareaCover-${this.mentionableId}`
                ].style.marginLeft = `0`;
            }
            if (this.inputs[i]?.className && this.inputs[i].className.includes('show-mentions')) {
                this.$refs[
                    `textareaCover-${this.mentionableId}`
                ].style.paddingLeft = `0px`;
                this.$refs[
                    `textareaCover-${this.mentionableId}`
                ].style.paddingTop = `0px`;
                this.$refs[
                    `textareaCover-${this.mentionableId}`
                ].style.paddingBottom = `0px`;
                this.$refs[
                    `textareaCover-${this.mentionableId}`
                ].style.width = `calc(${this.inputs[i].clientWidth}px + ${this.inputs[i].scrollLeft}px + 5px)`;

                this.inputs[i].style.width = `calc(${this.$refs[
                    `textareaCover-${this.mentionableId}`
                ].clientWidth}px)`
                
            }
        },

        txtScroll(i) {
            this.$refs[
                `textareaCover-${this.mentionableId}`
            ].scrollTop = this.inputs[i].scrollTop;
            this.resize(i);
        },
        getInputs() {
            this.inputs = document.querySelectorAll(
                `.mentionable-${this.mentionableId} input, .mentionable-${this.mentionableId} textarea, .mentionable-${this.mentionableId} .show-mentions`
            );
            this.inputs.forEach((input, i) => {
                input.addEventListener("input", event => {
                    this.getValue(i);
                    this.txtScroll(i);
                });
                input.addEventListener("scroll", event => {
                    this.txtScroll(i);
                });
                input.addEventListener("mousemove", event => {
                    this.getValue(i);
                    this.txtScroll(i);
                });

                this.getValue(i);
            });
        },
        getValue(i) {
            this.value = this.inputs[i]?.value || this.inputs[i]?.innerHTML || '';
        }
    },

    created() {
        this.mentionableId = crypto.randomUUID();
    },

    mounted() {
        this.getInputs();
        setTimeout(() => {
            this.inputs.forEach((e, i) => {
                window.addEventListener("resize" + i, this.resize(i));
                this.$once("hook:beforeDestroy", () => {
                    window.removeEventListener("resize" + i, this.resize(i));
                });
            });
        });
    }
};
</script>

<style lang="scss">
[id^="popover_"].tooltip {
    display: block !important;
    z-index: 10000;

    .tooltip-inner {
        background: black;
        color: white;
        border-radius: 16px;
        padding: 5px 10px 4px;
    }

    .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: black;
        z-index: 1;
    }

    &[x-placement^="top"] {
        margin-bottom: 5px;

        .tooltip-arrow {
            border-width: 5px 5px 0 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            bottom: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    &[x-placement^="bottom"] {
        margin-top: 5px;

        .tooltip-arrow {
            border-width: 0 5px 5px 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-top-color: transparent !important;
            top: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    &[x-placement^="right"] {
        margin-left: 5px;

        .tooltip-arrow {
            border-width: 5px 5px 5px 0;
            border-left-color: transparent !important;
            border-top-color: transparent !important;
            border-bottom-color: transparent !important;
            left: -5px;
            top: calc(50% - 5px);
            margin-left: 0;
            margin-right: 0;
        }
    }

    &[x-placement^="left"] {
        margin-right: 5px;

        .tooltip-arrow {
            border-width: 5px 0 5px 5px;
            border-top-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            right: -5px;
            top: calc(50% - 5px);
            margin-left: 0;
            margin-right: 0;
        }
    }

    &.popover {
        .popover-inner {
            background: none;
            color: #2a3042;
            padding: 10px;
            border-radius: 5px;
            // box-shadow: 0 5px 30px rgba(black, 0.1);
        }

        .popover-arrow {
            border-color: aliceblue;
        }
    }

    &[aria-hidden="true"] {
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.15s, visibility 0.15s;
    }

    &[aria-hidden="false"] {
        visibility: visible;
        opacity: 1;
        transition: opacity 0.15s;
    }
}

.textarea-cover {
    z-index: 1;
    position: absolute;
    color: transparent;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    overflow-y: hidden;
    padding: 6px 12px;
    border: 1px solid transparent;
    // padding-right: 105px;
    // padding-bottom: 70px;
    font-size: 0.98rem;
    line-height: 1.75rem;
    // margin-left: 5px;
    padding-left: 12px;
    padding-right: 0 !important;
}

.txtcontent {
    width: 100%;
}

.mention-str {
    // color: #dfe6e8;
    // background-color: rgb(160, 165, 167);
    background: #3a4258;
    color: aliceblue;
    padding: 2px 11px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid white;
}

.mention-item {
    padding: 4px 10px;
    border-radius: 4px;
    cursor: pointer;
    background: white;
    position: relative !important;
    left: 70px;
    bottom: 0 !important;
}

.mention-selected {
    background: #3a4258;
    color: aliceblue;
}
.position-relative {
    position: relative;
}

.show-mentions {
    display: inline-block;
    min-height: 40px;
    font-size: 0.98rem !important;
    line-height: 1.75rem !important;
    padding-right: 4px;
}

.mentionable-container input {
    font-size: 0.98rem;
    line-height: 1.75rem;

}

</style>
